import "../../../../content/projects/vpohod/vpohod.css";
import * as React from 'react';
export default {
  React
};